import React, { memo } from 'react'
import styled from 'styled-components'
import { useSelector } from 'react-redux'
import EstimateCapture from '../layer/EstimateCapture'

const EstimateSave = () => {
    const minishopInfo = useSelector(state => state.initial.minishopInfo)
    const estimateItems = useSelector(state => state.estimateAdd.estimateItems)
    const priceType = useSelector(state => state.estimateAdd.priceType)
    const [captureFlag, setCaptureFlag] = React.useState(false)
    const mallId = minishopInfo || {}
    const estimateLength = estimateItems?.estimateItems?.split(',').length || 0
    let popHeight = 410 + (40 * estimateLength)
    if (popHeight > 800) {
        popHeight = 800
    }

    const { isLogin } = useSelector(state => state.user)

    // const estimatePopView = () => {
    //     window.open(`/estimateSave/${mallId.idx_b_manager || 1}/${priceType}`, '_blank', `top=100, left=100, width=700, height=${popHeight}`)
    // }
    //
    // const estimatePopView2 = () => {
    //     window.open(`/estimateSave2/${mallId.idx_b_manager || 1}/${priceType}`, '_blank', `top=100, left=100, width=700, height=${popHeight}`)
    // }

    const onCaptureHandler = () => {
        /**
         * 240223 구매번호필요해서 로그인 확인 추가
         * */
        if (!isLogin) {
            window.location.href = process.env.REACT_APP_SSO_URL
        }else{
            setCaptureFlag((prev)=>{return !prev})
        }
    }

    return (
        <Style>
            <DownButton type="button" className="button" onClick={onCaptureHandler}>
                <div title="견적 캡처하기">
                    <i className="icon-ic_down" />
                </div>
            </DownButton>
            {/*<DownButton type="button" className="button" onClick={estimatePopView}>*/}
            {/*    <div title="견적 캡처하기(배너포함)">*/}
            {/*        <i className="icon-ic_down" />*/}
            {/*    </div>*/}
            {/*</DownButton>*/}
            {/*<DownButton type="button" className="button" onClick={estimatePopView2}>*/}
            {/*    <div title="견적 캡처하기">*/}
            {/*        <i className="icon-ic_down" />*/}
            {/*    </div>*/}
            {/*</DownButton>*/}
            {captureFlag&&<EstimateCapture priceType={priceType} minishopIdx={mallId.idx_b_manager} onCaptureHandler={onCaptureHandler}/>}
        </Style>
    )
}

const Style = styled.div``
const DownButton = styled.button`
    &.button {
        margin: 0 5px 0 0;
        border: 1px solid #999;
        width: 36px;
        height: 36px;
        border-radius: 18px;
        color: #999;
        font-size: 18px;

        &:hover {
            color: #418ded;
            border-color: #418ded;
        }
    }
`

export default memo(EstimateSave)



// WEBPACK FOOTER //
// ./src/estimate_list/components/estimate_save/index.js